import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import apiService from "../../service/apiService";
import pageData from "../../pages.json";
import { Button, Form, Card, CardHeader } from "react-bootstrap";
import { Box } from "@mui/material";
import Header from "../../components/Header";
import { useNavigate } from "react-router-dom";

const UserRoleInd = () => {
  const { userRoleId } = useParams();
  const [selectedPages, setSelectedPages] = useState([]);
  const navigate = useNavigate();

  

  const fetchUserData = async () => {
    try {
      const response = await apiService.get(`/rbac/get-form-by-user-role/${userRoleId}`);
      console.log("response is", response.data.body);
  
      const formIds = [];
      response.data.body.forEach((item) => {
        formIds.push(item.formId);
        if (item.subForms) {
          item.subForms.forEach((subForm) => {
            formIds.push(subForm.formId); 
          });
        }
      });
  
      setSelectedPages(formIds); 
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const getFlatPages = (pages) => {
    const mainPages = [];
    const innerPages = [];
  
    Object.entries(pages).forEach(([key, value]) => {
      mainPages.push({
        formId: key,
        formName: value.name,
        subForms: value.innerPages ? Object.keys(value.innerPages) : [],
        displayOrder: value.displayOrder,
      });
  
      if (value.innerPages) {
        Object.entries(value.innerPages).forEach(([innerKey, innerValue]) => {
          innerPages.push({
            formId: innerKey,
            formName: innerValue.name,
            parentFormId: key,
            displayOrder: innerValue.displayOrder,
          });
        });
      }
    });
  
    return { mainPages, innerPages };
  };
  
  const flatPages = getFlatPages(pageData.pages);
  // console.log("first data are", flatPages);
  const { mainPages, innerPages } = flatPages;
  
  const handleCheckboxChange = (pageId, isMainPage) => {
    setSelectedPages((prev) => {
      if (isMainPage) {
        const isAlreadySelected = prev.includes(pageId);
        const relatedInnerPages = mainPages.find((page) => page.formId === pageId)?.subForms || [];
  
        if (isAlreadySelected) {
          return prev.filter((id) => id !== pageId && !relatedInnerPages.includes(id));
        } else {
          return [...prev, pageId, ...relatedInnerPages];
        }
      } else {
        const parentPageId = innerPages.find((page) => page.formId === pageId)?.parentFormId;
        if (parentPageId && !prev.includes(parentPageId)) {
          return prev;
        }
  
        return prev.includes(pageId) ? prev.filter((id) => id !== pageId) : [...prev, pageId];
      }
    });
  };
  

  const handleUpdate = async () => {
    const newPayload = {
      userRoleId: userRoleId,
      forms: mainPages
        .map((mainPage) => {
          if (selectedPages.includes(Number(mainPage.formId))) {
            return {
              formId: mainPage.formId,
              formName: mainPage.formName,
              displayOrder: mainPage.displayOrder,
              subForms: innerPages
                .filter(
                  (innerPage) =>
                    innerPage.parentFormId === mainPage.formId &&
                    selectedPages.includes(Number(innerPage.formId))
                )
                .map((innerPage) => ({
                  formId: innerPage.formId,
                  formName: innerPage.formName,
                  displayOrder: innerPage.displayOrder,
                })),
            };
          }
          return null;
        })
        .filter((form) => form !== null), 
    };
  
    console.log("Payload for PUT request:", newPayload);
  
    try {
      const response = await apiService.put("/rbac/update-access", newPayload);
      console.log("add response:", response.data);
      if(response.data.status === true){
        window.alert("Access Updated Successfully");
        navigate(-1);
      }
    } catch (error) {
      console.error("Error updating pages:", error);
    }
  };
  
  useEffect(() => {
    fetchUserData();
  }, []); 
  return (
    <Box m="2px">
      <div style={{ maxHeight: "100vh", overflowX: "auto" }}>
      <div className="d-flex justify-content-between align-items-center mx-3">
      <Header title="Edit Access"/>
      </div>
        <Card className="mx-5">
          <CardHeader>
            <div className="d-flex justify-content-between">
              <h5>Select Pages For Access</h5>
              <Button variant="primary" onClick={handleUpdate}>
                Update Access
              </Button>
            </div>
          </CardHeader>
          <Form className="p-4">
            {mainPages.map((page) => (
              <div key={page.formId}>
                <Form.Check
                  type="checkbox"
                  label={page.formName}
                  checked={selectedPages.includes(Number(page.formId))}
                  onChange={() => handleCheckboxChange(Number(page.formId), true)}
                  className="mb-2 main-page"
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                  }}
                />
                {innerPages
                  .filter((innerPage) => innerPage.parentFormId === page.formId)
                  .map((innerPage) => (
                    <Form.Check
                      key={innerPage.formId}
                      type="checkbox"
                      label={innerPage.formName}
                      checked={selectedPages.includes(Number(innerPage.formId))}
                      onChange={() => handleCheckboxChange(Number(innerPage.formId), false)}
                      className="mb-2 inner-page"
                      style={{
                        fontWeight: "normal",
                        fontSize: "14px",
                        marginLeft: "20px",
                      }}
                      disabled={!selectedPages.includes(Number(page.formId))} // Disable if main page is not selected
                    />
                  ))}
              </div>
            ))}
          </Form>
        </Card>
      </div>
    </Box>
  );
};

export default UserRoleInd;